import { render, staticRenderFns } from "./AssetCard.vue?vue&type=template&id=cb48623a&scoped=true"
import script from "./AssetCard.vue?vue&type=script&lang=js"
export * from "./AssetCard.vue?vue&type=script&lang=js"
import style0 from "./AssetCard.vue?vue&type=style&index=0&id=cb48623a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb48623a",
  null
  
)

export default component.exports